// extracted by mini-css-extract-plugin
export var container = "_2u-1";
export var editor = "_2u-2";
export var resizable = "_2u-3";
export var wrapper = "_2u-0";